import React from 'react';
import { 
  ShieldCheckIcon, 
  TruckIcon, 
  HeartIcon,
  ClockIcon,
  SparklesIcon,
  CheckBadgeIcon
} from '@heroicons/react/24/outline';

const TrustBadges = ({ variant = 'horizontal', className = '' }) => {
  const badges = [
    {
      icon: ShieldCheckIcon,
      title: '100% אותנטי',
      description: 'בשמים מקוריים מיבואן רשמי',
    },
    {
      icon: TruckIcon,
      title: 'משלוח חינם',
      description: 'הזמנות מעל ₪200',
    },
    {
      icon: HeartIcon,
      title: '10,000+ לקוחות',
      description: 'מרוצים ומלקוחות חוזרים',
    },
    {
      icon: ClockIcon,
      title: 'שירות 24/7',
      description: 'תמיכה מהירה ומקצועית',
    },
    {
      icon: SparklesIcon,
      title: 'החזרות קלות',
      description: 'תוך 30 יום ללא שאלות',
    },
    {
      icon: CheckBadgeIcon,
      title: 'אחריות יבואן',
      description: 'מוצרים מובטחים ומוגנים',
    }
  ];

  if (variant === 'compact') {
    return (
      <div className={`flex flex-wrap gap-3 justify-center ${className}`}>
        {badges.slice(0, 3).map((badge, index) => (
          <div
            key={index}
            className="flex items-center gap-2 px-4 py-2 bg-white rounded-full border border-gray-200"
          >
            <badge.icon className="h-4 w-4 text-gray-600" />
            <span className="text-sm font-medium text-gray-700">{badge.title}</span>
          </div>
        ))}
      </div>
    );
  }

  if (variant === 'vertical') {
    return (
      <div className={`space-y-3 ${className}`}>
        {badges.map((badge, index) => (
          <div
            key={index}
            className="p-4 rounded-lg border border-gray-200 hover:border-gray-300 transition-colors"
          >
            <div className="flex items-start gap-3">
              <div className="p-2 rounded-lg bg-gray-100">
                <badge.icon className="h-5 w-5 text-gray-600" />
              </div>
              <div className="flex-1">
                <h4 className="font-semibold text-gray-900 mb-0.5 text-sm">{badge.title}</h4>
                <p className="text-xs text-gray-500">{badge.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  // Default horizontal variant
  return (
    <div className={`${className}`}>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {badges.map((badge, index) => (
          <div
            key={index}
            className="p-6 rounded-sm bg-cream-50/80 border border-cream-400/40 hover:border-gold-400/40 transition-colors duration-300"
          >
            <div className="mb-3">
              <div className="inline-flex p-2.5 rounded-sm bg-gold-100/80 border border-gold-300/30">
                <badge.icon className="h-5 w-5 text-gold-600" />
              </div>
            </div>
            
            <h3 className="text-sm font-semibold text-charcoal-900 mb-1">{badge.title}</h3>
            <p className="text-xs text-charcoal-700/70">{badge.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustBadges;

